import React from 'react';
import ParkingAreaMarker from './ParkingAreaMarker';

const ParkingAreaMarkersLayer = ({ features }) => (
  <div>
    {
      features.map((feature, i) => {
        // const { FID } = feature.properties;
        return (
          <ParkingAreaMarker key={i} feature={feature} />
        );
      })
    }
  </div>
);

export default ParkingAreaMarkersLayer;



// WEBPACK FOOTER //
// ./src/containers/MapLayers/ParkingAreaMarkersLayer.js